import { StyleSheet } from 'aphrodite';
import { borderColor, brandPrimary, white } from '../../../styles/colors';
import { CssSelectors } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	content: {
		minHeight: 200,
	},
	dropdown: {
		width: 300,
	},
	oppsLoadingSpinner: {
		marginTop: '10%',
	},
	richContentFilterOptionsContainer: {
		borderBottom: `1px solid ${borderColor}`,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		padding: '15px 0',
	},
	tabContainer: {
		height: '100%',
		display: `flex`,
		flexDirection: `column`,
		overflowY: 'auto',
	},
	tabContent: {
		flex: 1,
		overflow: 'hidden',
		":is([data-state='active'])": {
			display: `flex`,
			flexDirection: 'column',
		},
	},
	tabList: {
		borderBottom: `1px solid ${borderColor}`,
		boxSizing: `border-box`,
		display: `flex`,
		width: `100%`,
		background: white,
	},
	tabTrigger: {
		flexGrow: 1,
		flexBasis: 0,
		fontSize: `0.875rem`,
		justifyContent: `center`,
		alignItems: `center`,
		display: `flex`,
		textTransform: 'uppercase',
		letterSpacing: `1.2px`,
		textDecoration: 'none',
		padding: 20,
		':is([data-state="active"])': {
			color: brandPrimary,
			borderBottom: `3px solid ${brandPrimary}`,
		},
	},
	tabView: {
		...CssSelectors.allDescendants(
			{
				overflow: 'unset',
			},
			'.scroll-view-content'
		),
	},
	timelineFilterOptionsContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		paddingTop: 15,
		...CssSelectors.allChildren({
			borderRadius: 30,
		}),
	},
});
